import { render } from "./InformationsList.vue?vue&type=template&id=04824bf8&scoped=true"
import script from "./InformationsList.vue?vue&type=script&lang=js"
export * from "./InformationsList.vue?vue&type=script&lang=js"

import "./InformationsList.vue?vue&type=style&index=0&id=04824bf8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04824bf8"

export default script